import React, { useState } from "react";
import {
    Button,
    Typography,
    Box,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
} from "@material-ui/core";
import {
    AttachFile,
    PictureAsPdf,
    Image,
    Delete,
    Cancel,
    InsertDriveFile,
    Description,
} from "@material-ui/icons";

const FileUploader = ({ onFilesChange, disabled }) => {
    const [previews, setPreviews] = React.useState([]);

    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const newPreviews = [];

        files.forEach((file) => {
            if (file.size > MAX_FILE_SIZE) {
                alert(
                    `Файл ${file.name} превышает максимальный размер в 10 МБ.`,
                );
            } else {
                newPreviews.push({
                    file,
                    preview: file.type.startsWith("image/")
                        ? URL.createObjectURL(file)
                        : null,
                    name: file.name,
                });
            }
        });

        setPreviews([...previews, ...newPreviews]);
        onFilesChange([...previews, ...newPreviews].map((p) => p.file));
    };

    const removeFile = (index) => {
        const updatedPreviews = [...previews];
        if (updatedPreviews[index].preview) {
            URL.revokeObjectURL(updatedPreviews[index].preview);
        }
        updatedPreviews.splice(index, 1);
        setPreviews(updatedPreviews);
        onFilesChange(updatedPreviews.map((p) => p.file));
    };

    const getFileIcon = (fileType) => {
        if (fileType.startsWith("image/")) return <Image color="primary" />;
        if (fileType === "application/pdf")
            return <PictureAsPdf color="secondary" />;
        return <Description />;
    };

    return (
        <div>
            <input
                type="file"
                multiple
                onChange={handleFileChange}
                style={{ display: "none" }}
                id="file-upload"
                disabled={disabled}
            />
            <label htmlFor="file-upload">
                <Button
                    variant="contained"
                    component="span"
                    disabled={disabled}
                    style={{ marginBottom: "16px" }}
                >
                    Выбрать файлы
                </Button>
            </label>

            <Box display="flex" flexWrap="wrap" gap="16px">
                {previews.map((preview, index) => (
                    <Box
                        key={index}
                        position="relative"
                        width="100px"
                        height="100px"
                        border={1}
                        borderColor="grey.300"
                        borderRadius={4}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        overflow="hidden"
                    >
                        <IconButton
                            size="small"
                            style={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                                backgroundColor: "rgba(255,255,255,0.7)",
                            }}
                            onClick={() => removeFile(index)}
                        >
                            <Cancel fontSize="small" />
                        </IconButton>

                        {preview.preview ? (
                            <img
                                src={preview.preview}
                                alt="Preview"
                                style={{
                                    maxWidth: "100%",
                                    maxHeight: "70px",
                                    objectFit: "contain",
                                }}
                            />
                        ) : (
                            <Box textAlign="center">
                                {getFileIcon(preview.file.type)}
                            </Box>
                        )}

                        <Box
                            width="100%"
                            textAlign="center"
                            fontSize="0.7rem"
                            padding="4px"
                            bgcolor="grey.100"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {preview.name}
                        </Box>
                    </Box>
                ))}
            </Box>
        </div>
    );
};

export default FileUploader;
